import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { AlertController } from "ionic-angular";
import * as moment from "moment-timezone";

@Component({
  selector: "pain-site-card-sidebar",
  templateUrl: "pain-site-card-sidebar.html",
})
export class PainSiteCardSidebarComponent implements AfterViewInit {
  @Input() painService;
  @Input() section: string;
  @Input() access: string;
  @Output() onPointDelete: EventEmitter<any> = new EventEmitter();
  @Output() numberOfPoints: EventEmitter<any> = new EventEmitter();

  points = [];

  dataPages: Array<object[]> = [];
  pageSize: number = 10;
  currentPage: number = 0;
  selectedWoundTypes: Array<string> = [];
  selectedDrainage: Array<string> = [];
  dummyRow: object;
  subscriptions: Array<any> = [];

  constructor(
    private alertCtrl: AlertController,
    public translatePipe: TranslateService
  ) {}

  ngAfterViewInit() {
    this.subscriptions.push(
      this.painService.getAllPointDataObservable().subscribe((data) => {
        if (!data || !data.points) {
          return;
        }

        let points = data.points;
        this.points = points;
        for (let i = 0; i < this.points.length; i++) {
          this.points[i].index = i;
        }

        // this.pointsArray = Object.keys(this.points).map((key)=>{return this.points[key]})

        this.updateDataPages();
        this.numberOfPoints.emit(this.points.length);
      })
    );
  }

  ngOnDestroy() {
    for (let sub of this.subscriptions) {
      sub.unsubscribe();
    }
    this.subscriptions = [];
  }

  selectPoint(index) {
    this.painService.selectPoint(index);
    if (this.section === "skin") {
      this.selectedWoundTypes = [];
      if (this.points[index].woundType) {
        for (let type in this.points[index].woundType) {
          if (this.points[index].woundType[type] === true) {
            this.selectedWoundTypes.push(type);
          }
        }
      }
      this.selectedDrainage = [];
      if (this.points[index].drainage) {
        for (let type in this.points[index].drainage) {
          if (
            type !== "selectAll" &&
            this.points[index].drainage[type] === true
          ) {
            this.selectedDrainage.push(type);
          }
        }
      }
    }
  }

  setCategory(category) {
    this.painService.setCategory(category);
  }

  addPoint() {
    this.painService.addPoint();
  }

  removePoint(index) {
    let alert = this.alertCtrl.create({
      title: this.translatePipe.instant("confirmDeleteRecord"),
      buttons: [
        {
          text: "Cancel",
        },
        {
          text: "Proceed",
          handler: () => {
            this.onPointDelete.emit(index);
            this.currentPage = 0;
          },
        },
      ],
    });
    alert.present();
  }

  updateActivePointData(key, value) {
    this.painService.updateActivePointData(key, value);
  }

  updateDataPages() {
    this.dataPages = [];
    this.dummyRow = { x: "", y: "", dummy: true };

    let dataRows = this.points;
    let pageSize = this.pageSize;
    let dataPages = this.dataPages;
    let pageIndex = -1;
    for (let i = 0; i < dataRows.length; i++) {
      let j = i % pageSize;
      if (j == 0) {
        dataPages.push([]);
        pageIndex++;
      }
      dataPages[pageIndex][j] = dataRows[i];
    }
    if (pageIndex > 0) {
      let endingRow = dataRows.length % this.pageSize;
      if (endingRow > 0) {
        for (let i = endingRow; i < this.pageSize; i++) {
          dataPages[pageIndex][i] = this.dummyRow;
        }
      }
    }

    //reset to first page if active element is deleted
    let newCurrentPage = this.currentPage;
    for (let i = 0; i < this.points.length; i++) {
      if (this.points[i].active) {
        newCurrentPage = Math.floor(i / pageSize);
      }
    }
    this.currentPage = newCurrentPage;
  }

  prevPage() {
    if (this.currentPage > 0) {
      this.currentPage--;
    }
  }

  nextPage() {
    if (this.currentPage < this.dataPages.length - 1) {
      this.currentPage++;
    }
  }

  getTime(data) {
    return moment(data).local().format("MM/DD/YYYY HH:mm");
  }

  getHeaderText(point) {
    if (point.severity === 0 && point.cardId == "CL010.3") {
      return (
        point.index + 1 + ": " + this.translatePipe.instant("painAssessed")
      );
    } else if (point.severity > 0 && point.cardId == "CL010.3") {
      if (point.unspecifiedLocation) {
        return (
          point.index + 1 + ": " + this.translatePipe.instant("generalizedPain")
        );
      } else {
        return (
          point.index +
          1 +
          ": " +
          point.name +
          " (" +
          this.translatePipe.instant(point.category) +
          ") "
        );
      }
    } else {
      return (
        point.index +
        1 +
        ": " +
        point.name +
        " (" +
        this.translatePipe.instant(point.category) +
        ") "
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/cards/pain-site-card-sidebar/pain-site-card-sidebar.ts